export * from './segments.component'